<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>业务终审单说明:</h5><br>
				<span>1、单号构成规则:201201+类型拼音首字母+4位顺序号。系统生成,添加无效</span><br>
				<span>2、类型说明:TX=调薪,JX=绩效,</span><br>
				<span>3、查询关键字:单号、部门、申请人。</span><br>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

			<!-- <template slot="slot_c_out_fee">
            <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
              :selectValue="sel_fee" />
          </template> -->

		</pre-base>
	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '业务终审',
					"control": "salarypass",
					"isTwo": "0",
					"isTwoDetail": "0",
					"isFileMain": "1",
					"sel_action": 'exp_kq_s_pass',
					"upd_action": 'exp15_kq_s_pass',
					"step": '1',
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 's_pass',
					"p1": 'kq',
					"p2": 's_pass',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "select",
							"class": "long1",
							"sel_action": '_base_dep',
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "select",
							"class": "long1",
							"sel_action": '_base_roleuser',
							"sel_name": "",
							"sel": "3"
						}
					],
					"parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "申请内容",
							"val": "",
							"key": "apply_data",
							"type": "textarea",
							"class": "long5",
							"p": "0",
							"x": "2",
							"r": "1"
						},
						{
							"name": "申请说明",
							"val": "",
							"key": "apply_note",
							"type": "textarea",
							"class": "long5",
							"p": "0",
							"x": "3",
							"r": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "4",
							"r": "0"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "申请单"
						},
						{
							"name": "部门"
						},
						{
							"name": "申请人"
						},
						{
							"name": "状态"
						},
						{
							"name": "申请内容"
						},
						{
							"name": "申请说明"
						},
						{
							"name": "备注"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},





		}
	};
</script>
<style>
</style>